import styles from '../style.module.css';
import MultiRangeSlider from './MultiRangeSlider';
import ButtonToggle from './ButtonToggle';

type Props = {
  minCyclingRange_init: number;
  maxCyclingRange_init: number;
  minRunningRange_init: number;
  maxRunningRange_init: number;
  displayCycling: boolean;
  displaySwimming: boolean;
  displayVirtualRide: boolean;
  displayRunning: boolean;
  toggleDisplayCycling: React.DispatchWithoutAction;
  toggleDisplayRunning: React.DispatchWithoutAction;
  toggleDisplaySwimming: React.DispatchWithoutAction;
  toggleDisplayVirtualRide: React.DispatchWithoutAction;
  handleCyclingRangeChange: ({
    min,
    max,
  }: {
    min: number;
    max: number;
  }) => void;
  handleRunningRangeChange: ({
    min,
    max,
  }: {
    min: number;
    max: number;
  }) => void;
};

const Filters = (props: Props) => {
  const {
    displayCycling,
    toggleDisplayCycling,
    displayRunning,
    toggleDisplayRunning,
    displaySwimming,
    toggleDisplaySwimming,
    displayVirtualRide,
    toggleDisplayVirtualRide,
    minCyclingRange_init,
    maxCyclingRange_init,
    handleCyclingRangeChange,
    minRunningRange_init,
    maxRunningRange_init,
    handleRunningRangeChange,
  } = props;

  return (
    <div className={styles.radioButtonsGridContainer}>
      <ButtonToggle
        active={displayCycling}
        onClick={toggleDisplayCycling}
        label="cycling"
        colorClass="color-cycling"
      />
      <ButtonToggle
        active={displayRunning}
        onClick={toggleDisplayRunning}
        label="running"
        colorClass="color-running"
      />
      <ButtonToggle
        active={displaySwimming}
        onClick={toggleDisplaySwimming}
        label="swimming"
        colorClass="color-swimming"
      />
      <ButtonToggle
        active={displayVirtualRide}
        onClick={toggleDisplayVirtualRide}
        label="virtual ride"
        colorClass="color-virtualride"
      />
      <MultiRangeSlider
        min={minCyclingRange_init}
        max={maxCyclingRange_init}
        onChange={handleCyclingRangeChange}
      />
      <MultiRangeSlider
        min={minRunningRange_init}
        max={maxRunningRange_init}
        onChange={handleRunningRangeChange}
      />
    </div>
  );
};

export default Filters;
